import { useMsal } from "@azure/msal-react";

import "../../assets/css/custom.css";
import Button from "react-bootstrap/Button";

export function handleLogout(instance) {
  instance.logoutRedirect().catch((e) => {
    console.error(e);
  });
}

export const UserLogout = () => {
  const { instance } = useMsal();
  return (
    <Button
      id="downloadXL"
      className="btn-excel"
      onClick={() => handleLogout(instance)}
    >
      Log out
    </Button>
  );
};
